import { Injectable } from '@angular/core';
import { UserStateService } from '../../../user/shared/services/user-state/user-state.service';
import { ApplicationGridService } from '../application-grid.service';
import { GridOptions } from 'ag-grid-community';
import { GridApplicationRowData } from '../../../dashboard/models/grid-application-row-data';

@Injectable({
    providedIn: 'root',
})
export class ApplicationGridOptionsService {
    constructor(private userStateService: UserStateService) {}

    getAdvisorHighlightingOptions(): GridOptions {
        return ApplicationGridService.getHighlightingGridOptions<GridApplicationRowData>(
            (data: GridApplicationRowData) =>
                data.isViewedByAdvisor !== true &&
                this.userStateService.user$.getValue()?.id === data.advisorId,
        );
    }
}
